// IE9+
function ready(fn) {
  if (document.readyState != "loading") {
    fn();
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

ready(function() {
  const expressPayment = document.querySelector(".dynamic-checkout");
  const alternativeOr = document.querySelector(
    ".alternative-payment-separator"
  );
  const button = document.querySelector("#continue_button");
  const splitRadio = document.querySelector(
    "#checkout_payment_gateway_38216990783"
  );

  const splitPaymentBox = document.querySelector(
    "div[data-select-gateway='38216990783']"
  );

  // other payment methods at checkout
  const payment1 = document.querySelector(
    "div[data-select-gateway='33615347776']"
  );
  const payment2 = document.querySelector(
    "div[data-select-gateway='32125976640']"
  );
  const payment3 = document.querySelector(
    "div[data-select-gateway='32125911104']"
  );
  const payment4 = document.querySelector(
    "div[data-subfields-for-gateway='32125976640']"
  );

  if (expressPayment) {
    expressPayment.style.display = "none";
  }

  if (alternativeOr) {
    alternativeOr.style.display = "none";
  }

  if (vsxRent || ssdRent || triggerRent) {
    if (payment1 && payment2 && payment3 && payment4) {
      document.querySelector(
        "div[data-select-gateway='33615347776']"
      ).style.display = "none";
      document.querySelector(
        "div[data-select-gateway='32125976640']"
      ).style.display = "none";
      document.querySelector(
        "div[data-select-gateway='32125911104']"
      ).style.display = "none";
      document.querySelector(
        "div[data-subfields-for-gateway='32125976640']"
      ).style.display = "none";
      splitRadio.checked = true;
    }
  } else if (vsxBuy || ssdBuy || triggerBuy) {
    if (splitPaymentBox) {
      splitPaymentBox.style.display = "none";
    }
  }
  else {
    if (splitPaymentBox) {
      splitPaymentBox.style.display = "none";
    }
  }
});
